import React from "react";
import glamorous from "glamorous";
import _ from "lodash";

import { LadChicletCSS, colorForLad } from "../../components/chiclets";
import RoutingMapView from "../map/RoutingMapView";

import { AddressOverlayPanel } from "../map/OverlayPanel";

import EventsListContainer from "../events/EventsListContainer";
import { ExceptionRow } from "../exceptions/ExceptionLink";
import {
  PanelContainer,
  Panel
} from "../../vendor/signal-widgets/components/panel";
import { getKeyFromSiteAndPart } from "../shipment-status/ShipmentsState";

const LocationDetailPanel = props => {
  const {
    shipments,
    location,
    locations,
    locationID,
    pushSearchView,
    searchShipments,
    setSearchFilter,
    clearSearchFilters,
    setSearch,
    setSearchCategory,
    exceptionTypes,
    H,
    platform,
    locationShipments,
    ladsList,
    eventHandler
  } = props;
  const selectedLad = _.get(location, "lad");
  const title = _.get(location, "name", "");

  // Get the key into the watchlist shipments
  let shipmentsTotals = { total_shipments: 0, details: [] };
  const itemIndex =
    location != null
      ? shipments.findIndex(
          d => d.item === getKeyFromSiteAndPart(location.id, null)
        )
      : -1;
  if (itemIndex >= 0) {
    shipmentsTotals = shipments[itemIndex].data;
  }

  let titleChiclet = null;
  let lad = null;
  if (location != null) {
    lad = ladsList.find(l => l.id === Number(location.lad.id));
    titleChiclet = lad ? (
      <LadChicletCSS lad={lad} width={40} height={40} showLadLabel />
    ) : null;
  }

  return (
    <Panel
      title={
        <glamorous.Div
          css={{
            display: "flex",
            flex: 100,
            flexDirection: "row",
            marginRight: "0.5em",
            alignItems: "center"
          }}
        >
          <glamorous.Div
            css={{
              marginRight: "1em",
              borderRadius: "3px",
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
              fontSize: "small"
            }}
          >
            {titleChiclet}
          </glamorous.Div>
          {title}
        </glamorous.Div>
      }
      canMaximize={false}
      style={{ border: "none" }}
      headerStyle={{
        backgroundColor: colorForLad(lad),
        color: "white",
        fontWeight: "300"
      }}
    >
      <glamorous.Div
        css={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <ExceptionRow
          shipmentsTotals={shipmentsTotals}
          site={locationID}
          part={null}
          pushSearchView={pushSearchView}
          searchShipments={searchShipments}
          setSearchFilter={setSearchFilter}
          clearSearchFilters={clearSearchFilters}
          setSearch={setSearch}
          setSearchCategory={setSearchCategory}
          locations={locations}
          exceptionTypes={exceptionTypes}
        />
        <glamorous.Div css={{ position: "relative", height: "100%" }}>
          <RoutingMapView
            H={H}
            platform={platform}
            selectedLocationId={locationID}
            mapLocations={[location]}
            selectedLad={selectedLad}
            shipments={locationShipments}
            ladsList={ladsList}
            eventHandler={eventHandler}
          />
          <AddressOverlayPanel
            {...this.props}
            location={location}
            pinColor={colorForLad(lad)}
          />
        </glamorous.Div>
      </glamorous.Div>
    </Panel>
  );
};

const Section = glamorous.section({
  display: "flex",
  height: "calc(100vh - 3em)",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "1em"
});

export default class LocationDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.eventHandler = this.eventHandler.bind(this);
  }
  eventHandler(val, type) {
    const { pushLocationsDetailView } = this.props;

    switch (type) {
      case "LOCATION_LINK":
        pushLocationsDetailView(val);
        break;
      default:
        break;
    }
  }
  componentDidMount() {
    const {
      locationID,
      fetchShipmentTotalsByLocation,
      fetchLocationShipments,
      clearLocationShipments
    } = this.props;

    clearLocationShipments();
    fetchShipmentTotalsByLocation(locationID);
    fetchLocationShipments(locationID);
  }

  componentWillReceiveProps(nextProps) {
    const { fetchShipment } = this.props;

    // Catch when our list of shipments is populated
    if (
      this.props.shipmentSummaries.length === 0 &&
      nextProps.shipmentSummaries.length > 0
    ) {
      nextProps.shipmentSummaries.forEach(function(shipment) {
        fetchShipment(shipment.id);
      });
    }
  }

  render() {
    const { shipments, location, locationShipments, ladsList } = this.props;

    return (
      <Section>
        <PanelContainer>
          <LocationDetailPanel
            {...this.props}
            shipments={shipments}
            location={location}
            locationShipments={locationShipments}
            ladsList={ladsList}
            eventHandler={this.eventHandler}
          />
        </PanelContainer>
        <EventsListContainer
          style={{ maxHeight: "calc(100vh - 3em)" }}
          shipments={locationShipments}
        />
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/location-detail/LocationDetailView.js